import { getUserCertificates } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserCertificates(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["users", "certificates", "course", `${username}`],
		fn: () => getUserCertificates(username),
	});

	const { certificates } = data || { certificates: [] };

	return { certificates, isPending, isSuccess, isError, error };
}
